<div class="carousel" [ngClass]="{ 'carousel--list': list }">
  <div class="carousel__inner">
    <ul class="carousel__slides" #carousel>
      <li *ngFor="let slide of slides" class="carousel__slides__slide">
        <ng-container [ngTemplateOutlet]="slide.template"></ng-container>
      </li>
      <ng-container *ngIf="hasEnoughSlides">
        <ng-container *ngFor="let slide of slides; let i = index">
          <li *ngIf="i < (list ? slideCount : 1)" class="carousel__slides__slide">
            <ng-container [ngTemplateOutlet]="slide.template"></ng-container>
          </li>
        </ng-container>
      </ng-container>
    </ul>

    <!-- Indicators -->
    <ul class="carousel__indicators" *ngIf="hasEnoughSlides">
      <ng-container *ngFor="let slide of slides; let i = index">
        <li (click)="onThumbClick($event, i)" [class.active]="i === currentSlide"></li>
      </ng-container>
    </ul>
  </div>

  <!-- Thumbs -->
  <div class="carousel__thumbs" *ngIf="slides.length > 1 && showThumbs">
    <ul>
      <ng-container *ngFor="let slide of slides; let i = index">
        <li [class.active]="i === currentSlide" (click)="onThumbClick($event, i)">
          <ng-container [ngTemplateOutlet]="slide.template"></ng-container>
        </li>
      </ng-container>
    </ul>
  </div>
</div>

<!-- controls -->
<div class="carousel__controls" [ngClass]="{ 'carousel--list': list }">
  <a *ngIf="hasEnoughSlides" class="carousel__control carousel__control--prev" (click)="previousSlide()">
    <i class="icon icon--md icon-ui-arrow--left"></i>
  </a>
  <a *ngIf="hasEnoughSlides" class="carousel__control carousel__control--next" (click)="nextSlide()">
    <i class="icon icon--md icon-ui-arrow--right"></i>
  </a>
</div>
